import { Container, Row, Col } from 'react-bootstrap';


export default function Footer() { 
  const currentYear = new Date().getFullYear();

  return (
    <footer>
      <Container>
        <Row>
          <Col className='text-center py-3'>
            <p>&copy;&nbsp;{currentYear} JDiskMark</p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};